import Vue from "vue"

export default new Vue({
  name: "XMLBacklogService",
  data: {},
  methods: {}
})



// WEBPACK FOOTER //
// ./src/XMLBacklog/XMLBacklogService.js